import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SeverityService {
getSeverity(statusId: number | undefined): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | undefined {
  if(statusId){
  
    if (statusId <= 5) {
      return 'info';
    } else if (statusId <= 7) {
      return 'warn';
    } else if (statusId <= 8) {
      return 'danger';
    } else if (statusId <= 19) {
      return 'success';
    } else {
      return undefined;
    }
  }
  return undefined;
}

  getEventSeverity(typeId: number): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | undefined  {
    if (typeId <= 5) {
      return 'info';
    } else if (typeId <= 7) {
      return 'warn';
    } else if (typeId <= 8) {
      return 'danger';
    } else if (typeId <= 19) {
      return 'success';
    } else {
      return 'secondary';
    }
  }

  getDraftingStatus(statusId: number): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | undefined  {
    if (statusId <= 5) {
      return 'info';
    } else if (statusId <= 7) {
      return 'warn';
    } else if (statusId <= 8) {
      return 'danger';
    } else if (statusId <= 19) {
      return 'success';
    } else {
      return 'secondary';
    }
  }

  findModSeverity(modId:number): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | undefined {
    if (modId = 2) {
      return undefined;
    } else if (modId = 3) {
      return 'success';
    } else if (modId = 4) {
      return 'warn';
    } else if (modId = 5) {
      return 'danger';
    } else {
      return 'secondary';
    }
  }
}